import styled, { css } from 'styled-components';

// Import styles
import { flex, customMinResponsive, size } from 'components/styles';

export const Container = styled.div<{ fullWidth: boolean }>`
	${flex({ jc: 'flex-end' })};
	align-self: flex-end;
	width: 100%;
	margin-top: 2.4rem;
	gap: 1rem;

	button:nth-child(1) {
		flex: 1;
	}

	button:nth-child(2) {
		flex: 4;
	}

	${customMinResponsive(
		size.xsmall,
		css`
			width: 36rem;
			button:nth-child(2) {
				flex: 1;
			}
		`
	)}};



	${({ fullWidth }) =>
		fullWidth &&
		customMinResponsive(
			size.large,
			css`
				width: 100%;
			`
		)}
`;
